import store from '../store/store';
import types from '../store/types';
import { IComponent, IOutput, IOutputValue, ISharedJourneyItem } from './interfaces';
import { PropertyHelper } from './';
import { Promise } from 'es6-promise';
import { getSharedJourneyOutputs, getSharedJourneys } from './io';

export class SharedJourneyHelper  {

	public static addSharedJourneyOutputs(sharedJourneyComponent: IComponent) {

		let promise:Promise<any> = new Promise<any>((resolve, reject) => {

			store.dispatch({
				type: types.ADD_SHARED_JOURNEY_OUTPUTS,
				componentId: sharedJourneyComponent.Id,
				outputs: sharedJourneyComponent.SharedJourney.OutputValues
			});

			resolve();

		});

		return promise;

	}

	public static resolveSharedJourneyOutputs(): Promise<any> {

		let sharedJourneyOutputPromises: Promise<any>[] = [];

		//loop through components
		let components = store.getState().processState.components;
		for(let componentId in components) {

			let component:IComponent = components[componentId];

			if(component.SharedJourney && component.SharedJourney.Properties && component.SharedJourney.Properties.length) {

				//get the journey id
				let journeyId = PropertyHelper.getPropertyValue(component.SharedJourney.Properties, 'JourneyId');
				if(journeyId) {
					//create a promise for each Shared Journey to retrieve and add the outputs to the output state
					//sharedJourneyOutputPromises.push(SharedJourneyHelper.storeSharedJourneyOutputs(journeyId, componentId));
					sharedJourneyOutputPromises.push(SharedJourneyHelper.addSharedJourneyOutputs(component));
				}

			}

		}

		let promise = new Promise<any>((resolve, reject) => {

			Promise.all(sharedJourneyOutputPromises).then(
				() => {
					resolve();
				},
				(error) => {
					reject(error);
				}
			);

		});

		return promise;

	}

	public static getSharedJourneyName(journeyId: string): string {
		let sharedJourneys:ISharedJourneyItem[] = store.getState().cacheState.sharedJourneys;
		let sharedJourney:ISharedJourneyItem = sharedJourneys.filter((s) => {
			return s.journeyId === journeyId;
		})[0];

		if(sharedJourney) {
			return sharedJourney.journeyName;
		}
		else {
			return null;
		}
	}

	public static storeSharedJourneyOutputs(journeyId: string, componentId: string): Promise<any> {

		let component = store.getState().processState.components[componentId];

		let promise:Promise<any> = new Promise<any>((resolve, reject) => {

			return SharedJourneyHelper.getSharedJourneyOutputs(journeyId).then(
				(outputs) => {

					let outputValues: IOutputValue[] = outputs;

					//update Group, DisplayOnSummary, and InputValue in retrieved outputs based on those set against SharedJourney at the moment
					let sharedJourneyOutputs: IOutput[] = component.SharedJourney.OutputValues;
					if(sharedJourneyOutputs) {
						for(let i = 0; i < sharedJourneyOutputs.length; i++) {
							let outputValue = outputValues.filter((v) => v.Id === sharedJourneyOutputs[i].Id)[0];
							if(outputValue) {
								outputValue.Group = sharedJourneyOutputs[i].Group;
								outputValue.DisplayOnSummary = sharedJourneyOutputs[i].DisplayOnSummary;
								outputValue.InputValue = sharedJourneyOutputs[i].InputValue;
							}
						}
					}

					//remove all existing outputs associated with componentId
					store.dispatch({
						type: types.DELETE_COMPONENT_OUTPUTS,
						componentId: componentId
					});

					store.dispatch({
						type: types.ADD_SHARED_JOURNEY_OUTPUTS,
						componentId: component.Id,
						outputs: outputValues
					});

					resolve();

				},

				(error) => {
					reject(error);
				}
			);

		});

		return promise;

	}

	public static getSharedJourneyOutputs(journeyId: string): Promise<any> {

		let promise = new Promise<any>((resolve, reject) => {

			getSharedJourneyOutputs(journeyId).then(
			
				(response) => {

					let outputs: IOutput[] = [].concat.apply([], response);
                    resolve(outputs);

				},

				(error) => {

					reject(error);	

				}

			);

		});

		return promise;

	}

	public static cacheAvailableSharedJourneys(): Promise<any> {

		let promise = new Promise<any>((resolve, reject) => {
			
			getSharedJourneys('%25').then( //TODO: have the API be updated so that passing an empty string returns all of the shared journeys

				(response) => {

					store.dispatch({
						type: types.UPDATE_SHARED_JOURNEYS,
						sharedJourneys: response
					});

					resolve(response);

				},

				(error) => {

					reject(error);

				}
			);

		});

		return promise;

	}

}


// WEBPACK FOOTER //
// ./source/ts/helpers/shared-journey.ts